import React, { Component } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import * as aserver from '../../APIClient';
import { Button } from '@material-ui/core';
import Modal from '../comps/modal';
import Toast from "../comps/alertMessage";
import LoadingBackdrop from '../comps/loadingBackdrop';

const drawerWidth = 240;

function processMessage(isLinkedToXero) { return(`When you order, you will be emailed an invoice within ${isLinkedToXero?'a few minutes':'one working day'}.
  Once we have received payment, your account will be credited.`)}
const processMessageMeantime = `
  In the meantime, please continue using the system.
  The discount (if applicable) will include the units used while we wait for your confirmation of payment.
  You don't need to wait for your credits to keep working.`;

const bulkorderemail = `cheryl@aephoriagroup.com`;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24,
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
}));

// eslint-disable-next-line
class Orders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pendingCredits: 0,
      modalIsOpen: false,
      amountCreditsToBeOrdered: 0,
      openBackdrop: false
    };
  }

  fetchData = async () => {
    let coachId = localStorage.getItem("Id");
    let result = await aserver.get(`api/v2/coaches/${coachId}`);
    this.setState({
      pendingCredits: result.data.pendingCredits,
      isLinkedToXero: result.data.xeroContactId
    });
  };

  cancelOrder = async () => {
    let coachId = localStorage.getItem("Id");
    let orderBulkCredits = await aserver.put(`api/v2/coaches/${coachId}`, {
      cancelCreditOrder: true,
    });
    if (orderBulkCredits.status === 200) {
      this.toastMessage("Success", "success");
      this.refreshTable();
    } else {
      this.toastMessage("An error occurred. Please try again.", "danger");
    }
  };

  orderCredits = async () => {
    let coachId = localStorage.getItem("Id");
    this.setState({ modalIsOpen: false, openBackdrop: true});
    let orderBulkCredits = await aserver.put(`api/v2/coaches/${coachId}`, {
      pendingCredits: this.state.amountCreditsToBeOrdered,
      newCreditOrder: true,
    });
    if (orderBulkCredits.status === 200) {
      this.toastMessage("Success", "success");
      this.refreshTable();
    } else {
      this.toastMessage("Failed", "danger");
    }
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  changeOrderAmount = (event) => {
    this.setState({ amountCreditsToBeOrdered: event.currentTarget.value });
  };

  toastMessage = (text, level) => {
    this.setState({ message: text, level });
    this.showToast();
  };

  showToast = () => {
    this.setState({ showToast: true }, () => {
      setTimeout(() => this.setState({ showToast: false }), 2500);
    });
  };

  refreshTable = () => {
    window.location.reload(false);
  };

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.closeModal();
    }
  };

  componentDidMount = () => {
    document.addEventListener("keydown", this.escFunction, false);
    this.fetchData();
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  render() {
    const classes = this.props.classes;
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);

    let PendingCreditOrder = <></>;

    if (this.state.pendingCredits === 0) {
      PendingCreditOrder = (
        <>
          <h3>You have no pending bulk credit purchase</h3>
          <Button variant="contained" color="primary" type="submit" onClick={() => this.openModal()}>
            Order credits in bulk
          </Button>
        </>
      );
    } else {
      PendingCreditOrder = (
        <>
          <h3>
            You have {this.state.pendingCredits} pending credits purchased in bulk - check your email inbox for the invoice. When we have processed your payment, the credits will reflect in your updated balance.
          </h3>
          <p>{processMessageMeantime}</p>
          <p>To cancel your bulk order, email <a href={'mailto:'+bulkorderemail+'?subject=Bulk Order Cancellation'} target="_blank" rel="noreferrer">{bulkorderemail}</a></p>
        </>
      );
    }

    return (
      <>
        <div className={classes.root}>
          <CssBaseline />
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
              <Grid item xs={12} md={12} lg={12}>
                <Paper className={fixedHeightPaper}>
                    <h3>Purchasing Credits</h3>
                    <p>
                      There are two ways to use your credits. Pay-as-you-go functionality allows you to use credits day
                      to day as you need them. You don't have to buy credits upfront. You will receive an invoice with
                      30-day payment terms at the end of each month for what you used in that month. Standard costs
                      without discounts apply if you use this option.
                    </p>
                    <p>
                      To qualify for bulk discounts, credits must be purchased and paid for upfront. Once payment has
                      been received, the credits will be loaded onto your portal.
                    </p>
                    <p>
                      If you have already used credits and would like them included in a bulk order, please place and 
                      pay for the bulk order before the end of the same month. Existing invoices for outstanding 
                      credits cannot be cancelled or converted into a discounted bulk order.
                    </p>
                    <p>
                      Bulk discounts apply only to upfront credit purchases, not to pay-as-you-go usage.
                    </p>
                    <p>The bulk discount sliding scale is as follows:</p>
                    <ul>
                      <li>1-49 credits: <a href="billing#costs">normal price</a></li>
                      <li>50-99 credits: 5% discount</li>
                      <li>100-199 credits: 10% discount.</li>
                      <li>200+ credits: 15% discount</li>
                    </ul>

                  <Grid>{PendingCreditOrder}</Grid>

                  <Modal id="ordersModal" isOpen={this.state.modalIsOpen} onClose={() => this.closeModal()}>
                    <h3>Bulk Order Credits</h3>
                    <p>{processMessage(this.state.isLinkedToXero)}</p><p>{processMessageMeantime}</p>
                    <p>Amount of credits you would like to order:</p>
                    <input
                      type="number"
                      min="10"
                      value={this.state.amountCreditsToBeOrdered}
                      onChange={this.changeOrderAmount}
                    />
                    <br />
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      disabled={this.state.amountCreditsToBeOrdered > 9 ? false : true}
                      onClick={() => this.orderCredits()}
                    >
                      Order credits in bulk
                    </Button>
                    <p><b>Note: After you place the order, you will be able to cancel the order by sending an email to Aephoria requesting cancellation.</b></p>
                  </Modal>


                  <Toast level={this.state.level} message={this.state.message} visible={this.state.showToast} />
                </Paper>
              </Grid>
            </Container>
            <LoadingBackdrop open={this.state.openBackdrop} />
          </main>
        </div>
      </>
    );
  }
}

// eslint-disable-next-line
export default () => {
  const classes = useStyles();
  return <Orders classes={classes} />;
};
